export default __webpack_public_path__ + "static/media/KZ.M.10.2266.aafb7072.svg";